<div class="purchase-dialog">
  <!-- Confirm State -->
  <ng-container *ngIf="state === 'confirm'">
    <h2 mat-dialog-title>Datenangebot erwerben</h2>

    <mat-dialog-content>
      <div class="purchase-offer-card">
        <div class="purchase-offer-card__title">{{ data.offerTitle }}</div>
        <div class="purchase-offer-card__producer">{{ data.producerOrgName }}</div>
        <div class="purchase-offer-card__reports">{{ data.reportCount }} Berichte</div>
      </div>

      <div class="purchase-price-highlight">{{ data.pricingLabel }}</div>

      <div class="purchase-details">
        <div class="purchase-detail-row">
          <mat-icon>verified_user</mat-icon>
          <span>{{ data.permissionsLabel }}</span>
        </div>
        <div class="purchase-detail-row">
          <mat-icon>schedule</mat-icon>
          <span>Gültigkeit: {{ data.validityLabel }}</span>
        </div>
      </div>

      <div class="purchase-error" *ngIf="error">
        <mat-icon>error</mat-icon>
        <span>{{ error }}</span>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-stroked-button (click)="cancel()">Abbrechen</button>
      <button mat-raised-button color="primary" (click)="confirm()">
        <mat-icon>shopping_cart</mat-icon>
        Jetzt kaufen
      </button>
    </mat-dialog-actions>
  </ng-container>

  <!-- Loading State -->
  <ng-container *ngIf="state === 'loading'">
    <mat-dialog-content class="purchase-loading">
      <mat-spinner diameter="48"></mat-spinner>
      <span class="purchase-loading__text">Zahlung wird verarbeitet...</span>
    </mat-dialog-content>
  </ng-container>

  <!-- Success State -->
  <ng-container *ngIf="state === 'success'">
    <mat-dialog-content class="purchase-success">
      <mat-icon class="purchase-success__icon">check_circle</mat-icon>
      <h3>Zahlung erfolgreich</h3>
      <p>Sie haben jetzt Zugriff auf die Daten.</p>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-raised-button color="primary" (click)="closeSuccess()">Schließen</button>
    </mat-dialog-actions>
  </ng-container>
</div>
